import axios from 'axios';
import config from '@/config/constants.js';

export default {
    namespaced: true,
    state: {
        status: '',
        submitProgress: 0,
        submitTotal: 0,
    },
    mutations: {
        loading(state) {
            state.status = 'loading';
        },
        status(state, status) {
            state.status = status;
        },
        success(state) {
            state.status = '';
            state.submitProgress = 0;
            state.submitTotal = 0;
        },
        setSubmitTotal(state, total) {
            state.submitTotal = total;
            state.submitProgress = 0;
        },
        incrementProgress(state) {
            state.submitProgress++;
        },
    },
    actions: {
        add_users: function ({commit, rootGetters}, users) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve) {
                commit('loading');
                commit('setSubmitTotal', users.length);
                let errorsCounter = 0;
                for (let i in users) {
                    let user = users[i];
                    user.phone = user.phone_number
                        .replaceAll(' ', '')
                        .replaceAll('-', '');
                    user.phone = config.phone_extension + user.phone;
                    let user_to_save = {
                        owner_id: rootGetters['Authenticate/current_user'].phone_number,
                        first_name: user.first_name,
                        last_name: user.last_name,
                        email: user.email,
                        phone_number: user.phone,
                        is_admin: user.is_admin,
                    };

                    try {
                        await axios.post(config.api_url + 'add_agent', user_to_save);
                        user['error'] = '';
                    } catch (error) {
                        errorsCounter++;
                        user['error'] = error.response.data.message;
                    }
                    commit('incrementProgress');
                }
                commit('success');
                resolve(errorsCounter);
            });
        },
    },
    getters: {
        user(state) {
            return state.user;
        },
        billing(state) {
            return state.billing;
        },
    },
    modules: {},
};
